import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";

@Injectable()
export class SurveySettingApi {
  private service: string = '';
  private model: string = 'polling';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  public getSurveyList() {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "getSurveyPeriodicList";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body, contentType);
  }

  public createPeriodicSurvey(params: any): Observable<any> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'createPeriodicSurvey';
    const _params: any = params || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, _params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, _params, urlParams, body, contentType);
  }

  public updatePeriodicSurvey(params: any): Observable<any> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'updatePeriodicSurvey';
    const _params: any = params || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, _params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, _params, urlParams, body, contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/survey-setting.api.ts